import { marketplaceType } from "@redotech/redo-model/catalog/catalog";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getMarketplaceVendors = {
  name: "getMarketplaceVendors" as const,
  input: z.object({ marketplaceType: createEnum(marketplaceType) }),
  output: z.object({ vendors: z.array(z.string()) }),
};
